module.exports = __webpack_public_path__ + "img/high-quality-construction.eb0290a.svg";